import React, { useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var AccuritySnackbar = function (props) {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(props.message), message = _b[0], setMessage = _b[1];
    useEffect(function () {
        // no message -> hide snackbar
        if (!props.message) {
            setIsOpen(false);
        }
        // message has been changed and snackbar is open, we want to close the snackbar
        // and then re-open it in onExited handler in order to achieve fadein-fadeout effect.
        // Otherwise just open the snackbar
        if (isOpen) {
            setIsOpen(false);
        }
        else if (props.message) {
            setIsOpen(true);
            setMessage(props.message);
        }
    }, [props.message]);
    var handleClose = function (event, reason) {
        // disallow closing Snackbar via clicking anywhere on screen
        if (reason !== 'clickaway') {
            props.onClose();
        }
    };
    var handleExited = function () {
        if (!!props.message) {
            setIsOpen(true);
            setMessage(props.message);
        }
    };
    return (React.createElement(Snackbar, { className: "accuritySnackbar", open: isOpen, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, action: (React.createElement(AccurityIconButton, { iconName: "mui:Close", size: "small", onClick: handleClose, color: "inherit", "aria-label": "snackBar__button" })), autoHideDuration: props.autoHideDuration || 3000, message: (React.createElement("span", null, message)), onClose: handleClose, TransitionProps: {
            onExited: handleExited
        } }));
};
export default AccuritySnackbar;
//# sourceMappingURL=AccuritySnackbar.js.map